import React from "react"

import { Section } from "@ua/web-sdk/lib/remote-data/preference-center"
import { SubscriptionOperatorProps } from "./types"
import Header from "./Header"
import Item from "./Item"
import { Box } from "@material-ui/core"

export type Props = SubscriptionOperatorProps & {
  section: Section
}

const Section: React.FC<Props> = ({ section, ...props }) => {
  const items = section.items?.map((item, idx) => (
    <Box key={item.id} mt={idx === 0 ? 0 : 2}>
      <Item key={item.id} item={item} {...props} />
    </Box>
  ))
  return (
    <Box>
      {section.display && <Header type="subheading" {...section.display} />}
      <Box mt={2}>{items}</Box>
    </Box>
  )
}

export default Section
